<template>
<div>
    <v-row justify-center v-if="loaded">
        <v-col cols="12" sm="8" offset-sm="2">

            <v-stepper alt-labels class="transparent elevation-0" v-model="e">
                <v-card flat class="mx-auto transparent" max-width="400">
                    <v-stepper-header class="elevation-0 transparent">
                        <v-stepper-step color="bMolecule" step="1" editable>Attributes</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step color="cyan accent-4" step="2" editable>Concepts</v-stepper-step>
                    </v-stepper-header>
                </v-card>

                <v-stepper-items class="transparent elevation-0 mt-n6">
                    <v-stepper-content step="1">
                        <EditAttributes
                            @changed="reinit"
                            @cancel="showEditAttributes=false"
                            :attributes="attributes"
                            v-if="showEditAttributes" />
                        <Attributes 
                            @continue="e=2"
                            @edit="showEditAttributes=true"
                            :attributes="attributes"
                            v-if="!showEditAttributes" />
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <EditConcepts
                            @changed="reinit"
                            @cancel="showEditConcepts=false"
                            :num="num"
                            :title="title"
                            :subtitle="subtitle"
                            :k="keyConcept"
                            :concepts="concepts"
                            v-if="showEditConcepts" />
                        <Concepts
                            @prev="e=1"
                            @edit="setEditConcepts"
                            :concepts="concepts"
                            v-if="!showEditConcepts" />
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </v-col>
    </v-row>

    <SendingLoader v-if="!loaded" />
</div>
</template>

<script>
import Helpers from '@/services/helpers'
import Sign from '@/firebase/sign'
import EditAttributes from '@/components/molecule/EditAttributes'
import Attributes from '@/components/molecule/Attributes'
import Concepts from '@/components/molecule/Concepts'
import EditConcepts from '@/components/molecule/EditConcepts'

export default {
    data: () => ({
        loaded: false,
        showEditAttributes: false,
        showEditConcepts: false,
        e: 1,
        attributes: {},
        concepts: {},
        num: '',
        title: '',
        subtitle: '',
        keyConcept: ''
    }),
    components: {
        EditAttributes,
        Attributes,
        EditConcepts,
        Concepts
    },
    watch: {
        e (val) {
            this.$emit('pestain', this.e);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        reinit(evt) {
            this.loaded = false;
            this.showEditAttributes = false;
            this.showEditConcepts = false;
            this.attributes = {},
            this.concepts = {};
            this.num = '';
            this.title = '';
            this.subtitle = '';
            this.keyConcept = '';

            if (evt == 'attributes')    this.e = 1;
            if (evt == 'concepts')      this.e = 2;
            
            Sign.reInitUser(this.user.uid);
            this.init();
        },
        init() {
            if (this.user.attributes != undefined) {
                this.attributes = this.user.attributes;
            } else {
                this.showEditAttributes = true;
            }

            if (this.user.concepts != undefined) {
                this.concepts = this.user.concepts;
            }

            this.loaded = true;
        },
        setEditConcepts(e) {
            if (e == 'feeling') {
                this.num = '1';
                this.title = 'MY FEELINGS';
                this.subtitle = 'Things you want to feel when you work at something.'
            }

            if (e == 'interestedIn') {
                this.num = '2';
                this.title = 'MY INTERESTS';
                this.subtitle = 'Things you would prefer to learn.'
            }

            if (e == 'goodAt') {
                this.num = '3';
                this.title = 'MY STRENGTHS';
                this.subtitle = 'Things you know you are good at.'
            }

            this.keyConcept = e;
            this.showEditConcepts = true;
        }
    }
}
</script>